import React, { useContext } from "react";

import { AppSettingsContext } from "@swa-ui/application";
import { AuthContext, corporateRoles } from "@swa-ui/authentication";
import { getBootstrapData } from "@swa-ui/bootstrap";
import { useDeviceInfo } from "@swa-ui/browser";
import { Link } from "@swa-ui/core";
import i18n from "@swa-ui/locale";

import { LocaleSwitcher } from "../LocaleSwitcher";
import { AnonymousInformation } from "./AnonymousInformation";
import { CtmInformation } from "./CtmInformation";
import { CustomerInformation } from "./CustomerInformation";
import { ThemeSelector } from "./ThemeSelector";

/**
 * DesktopHeaderControlCorporate provides the account and locale type controls in the header for a Corporate Customer.
 */

export const DesktopHeaderControlCorporate = (props) => {
  const { light } = props;
  const { appSettings } = useContext(AppSettingsContext);
  const { isLoggedInWithCorporateRole } = useContext(AuthContext);
  const { isLargeOrXlarge } = useDeviceInfo();
  const loggedInTraveler = isLoggedInWithCorporateRole(corporateRoles.TRAVELER);
  const loggedInAnonymous = isLoggedInWithCorporateRole(corporateRoles.ANONYMOUS);
  const loggedInCTM = isLoggedInWithCorporateRole(corporateRoles.CTM);
  const loggedIn = loggedInTraveler || loggedInAnonymous || loggedInCTM;

  return (
    <>
      {appSettings.themeSelector && <ThemeSelector />}
      {appSettings.loginAvailable && loggedIn ? renderLoggedIn() : renderLoggedOut()}
      {isLargeOrXlarge && <LocaleSwitcher light={light} />}
    </>
  );

  function renderLoggedIn() {
    let information = null;

    if (loggedInTraveler) {
      information = (
        <CustomerInformation
          accountLinkText="DesktopHeaderControl__TRAVELER_ACCOUNT"
          light={light}
          separator
        />
      );
    } else if (loggedInAnonymous) {
      information = <AnonymousInformation light={light} />;
    } else if (loggedInCTM) {
      information = <CtmInformation light={light} />;
    }

    return information;
  }

  function renderLoggedOut() {
    return <Link {...getLoginLinkProps()}>{i18n("DesktopHeaderControl__LOG_IN")}</Link>;
  }

  function getLoginLinkProps() {
    const { LOGIN__TO_YOUR_TRAVELER_ACCOUNT = "/login/" } = getBootstrapData("urls");

    return {
      emphasis: true,
      href: LOGIN__TO_YOUR_TRAVELER_ACCOUNT,
      light,
      prefixIcon: {
        name: "Passenger",
        role: "presentation",
        size: "size18",
      },
      size: "fontSize13",
    };
  }
};
DesktopHeaderControlCorporate.displayName = "DesktopHeaderControlCorporate";
